<p-drawer
  [visible]="visible()"
  position="right"
  (visibleChange)="onDrawerVisibleChange($event)"
  styleClass="charge-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-wallet text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle del cargo</h3>
      </div>
      @if (charge(); as charge) {
        @if (charge.sale?.id ?? charge.saleId; as saleId) {
          <a
            [routerLink]="['/sales', saleId]"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0">
            <i class="pi pi-shopping-cart text-sm"></i>
            Ver venta
          </a>
        }
      }
    </div>
  </ng-template>

  @if (charge(); as charge) {
    <div class="flex flex-col gap-4">
      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
            <i class="pi pi-wallet text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Cargo</span>
        </div>
        <div class="p-4">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
            <div>
              <p class="text-xs font-medium text-slate-500">Estado</p>
              <p-tag class="text-xs mt-0.5" [value]="getStatusLabel(charge.status ?? '')" [severity]="getStatusSeverity(charge.status ?? '') ?? undefined" />
            </div>
            @if (charge.collectionMethod) {
              <div>
                <p class="text-xs font-medium text-slate-500">Método de cobro</p>
                <p class="text-sm text-slate-700">{{ getCollectionMethodLabel(charge.collectionMethod) }}</p>
              </div>
            }
            @if (charge.paymentNumber != null && charge.numberOfPayments != null) {
              <div>
                <p class="text-xs font-medium text-slate-500">Pago</p>
                <p class="text-sm text-slate-700">Pago {{ charge.paymentNumber }} de {{ charge.numberOfPayments }}</p>
              </div>
            }
            <div>
              <p class="text-xs font-medium text-slate-500">Fecha de creación</p>
              <p class="text-sm text-slate-700">{{ charge.createdAt ? (charge.createdAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
            </div>
            <div>
              <p class="text-xs font-medium text-slate-500">Fecha de vencimiento</p>
              <p class="text-sm text-slate-700">{{ charge.dueDate ? (charge.dueDate | date:'dd/MM/yyyy') : '—' }}</p>
            </div>
            @if (charge.collectionStartDate) {
              <div>
                <p class="text-xs font-medium text-slate-500">Fecha de cobro</p>
                <p class="text-sm text-slate-700">{{ charge.collectionStartDate | date:'dd/MM/yyyy HH:mm' }}</p>
              </div>
            }
            @if (charge.paidAt) {
              <div>
                <p class="text-xs font-medium text-slate-500">Fecha de pago</p>
                <p class="text-sm text-slate-700">{{ charge.paidAt | date:'dd/MM/yyyy HH:mm' }}</p>
              </div>
            }
            <div class="sm:col-span-2 pt-2 border-t border-slate-100 grid grid-cols-2 gap-x-6 gap-y-2">
              <div>
                <p class="text-xs font-medium text-slate-500">Subtotal</p>
                <p class="text-sm text-slate-700">{{ (charge.subtotal ?? 0) | currency:'MXN':'symbol':'1.2-2' }}</p>
              </div>
              <div>
                <p class="text-xs font-medium text-slate-500">Impuestos</p>
                <p class="text-sm text-slate-700">{{ (charge.tax ?? 0) | currency:'MXN':'symbol':'1.2-2' }}</p>
              </div>
              <div>
                <p class="text-xs font-medium text-slate-500">Descuento</p>
                <p class="text-sm text-slate-700">{{ (charge.discount ?? 0) | currency:'MXN':'symbol':'1.2-2' }}</p>
              </div>
              <div>
                <p class="text-xs font-medium text-slate-500">Total del cargo</p>
                <p class="text-sm font-semibold text-slate-900">{{ (charge.total ?? 0) | currency:'MXN':'symbol':'1.2-2' }}</p>
              </div>
            </div>
            @if (charge.notes) {
              <div class="sm:col-span-2 pt-2 border-t border-slate-100">
                <p class="text-xs font-medium text-slate-500">Notas del cargo</p>
                <p class="text-sm text-slate-700 mt-0.5">{{ charge.notes }}</p>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
            <i class="pi pi-file-edit text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Venta</span>
        </div>
        <div class="p-4">
          @if (getChargeSale(charge); as sale) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              <div>
                <p class="text-xs font-medium text-slate-500">Número</p>
                <p class="text-sm font-semibold text-slate-900">
                  @if (sale.id) {
                    <a [routerLink]="['/sales', sale.id]" class="text-sky-600 hover:text-sky-800">{{ sale.number ?? charge.saleId ?? '—' }}</a>
                  } @else {
                    {{ sale.number ?? charge.saleId ?? '—' }}
                  }
                </p>
              </div>
              @if (sale.status != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Estado</p>
                  <p class="text-sm text-slate-700">{{ sale.status }}</p>
                </div>
              }
              @if (sale.processStatus != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Proceso</p>
                  <p class="text-sm text-slate-700">{{ sale.processStatus }}</p>
                </div>
              }
              @if (sale.saleType != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Tipo</p>
                  <p class="text-sm text-slate-700">{{ sale.saleType }}</p>
                </div>
              }
              @if (sale.issueDate) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Fecha de emisión</p>
                  <p class="text-sm text-slate-700">{{ sale.issueDate | date:'dd/MM/yyyy' }}</p>
                </div>
              }
              @if (sale.createdAt) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Creada</p>
                  <p class="text-sm text-slate-700">{{ sale.createdAt | date:'dd/MM/yyyy HH:mm' }}</p>
                </div>
              }
              @if (sale.currency != null || sale.total != null) {
                <div class="sm:col-span-2 pt-2 border-t border-slate-100 grid grid-cols-2 gap-x-6 gap-y-2">
                  @if (sale.subtotal != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Subtotal</p>
                      <p class="text-sm text-slate-700">{{ sale.subtotal | currency:(sale.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                  @if (sale.tax != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Impuestos</p>
                      <p class="text-sm text-slate-700">{{ sale.tax | currency:(sale.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                  @if (sale.discount != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Descuento</p>
                      <p class="text-sm text-slate-700">{{ sale.discount | currency:(sale.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                  <div>
                    <p class="text-xs font-medium text-slate-500">Total venta</p>
                    <p class="text-sm font-semibold text-slate-900">{{ (sale.total ?? 0) | currency:(sale.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                  </div>
                  @if (sale.amountDue != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Pendiente</p>
                      <p class="text-sm text-slate-700">{{ sale.amountDue | currency:(sale.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                </div>
              }
              @if (sale.notes) {
                <div class="sm:col-span-2 pt-2 border-t border-slate-100">
                  <p class="text-xs font-medium text-slate-500">Notas</p>
                  <p class="text-sm text-slate-700 mt-0.5">{{ sale.notes }}</p>
                </div>
              }
            </div>
          } @else {
            <p class="text-sm text-slate-500">Sin venta vinculada.</p>
          }
        </div>
      </div>

      @if (getChargeInvoice(charge); as invoice) {
        <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
          <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
            <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
              <i class="pi pi-file text-sm"></i>
            </span>
            <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Factura</span>
          </div>
          <div class="p-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              <div>
                <p class="text-xs font-medium text-slate-500">Serie / Número</p>
                <p class="text-sm font-semibold text-slate-900">
                  @if (invoice.id) {
                    <a [routerLink]="['/invoices', invoice.id]" class="text-sky-600 hover:text-sky-800">{{ invoice.series ?? '—' }}{{ invoice.series && invoice.number ? ' - ' : '' }}{{ invoice.number ?? '—' }}</a>
                  } @else {
                    {{ invoice.series ?? '' }}{{ invoice.number ?? '—' }}
                  }
                </p>
              </div>
              @if (invoice.status != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Estado factura</p>
                  <p class="text-sm text-slate-700">{{ invoice.status }}</p>
                </div>
              }
              @if (invoice.issueDate) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Fecha de emisión</p>
                  <p class="text-sm text-slate-700">{{ invoice.issueDate | date:'dd/MM/yyyy' }}</p>
                </div>
              }
              @if (invoice.currency != null || invoice.total != null) {
                <div class="sm:col-span-2 pt-2 border-t border-slate-100 grid grid-cols-2 gap-x-6 gap-y-2">
                  @if (invoice.subtotal != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Subtotal</p>
                      <p class="text-sm text-slate-700">{{ invoice.subtotal | currency:(invoice.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                  @if (invoice.tax != null) {
                    <div>
                      <p class="text-xs font-medium text-slate-500">Impuestos</p>
                      <p class="text-sm text-slate-700">{{ invoice.tax | currency:(invoice.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                    </div>
                  }
                  <div>
                    <p class="text-xs font-medium text-slate-500">Total factura</p>
                    <p class="text-sm font-semibold text-slate-900">{{ (invoice.total ?? 0) | currency:(invoice.currency ?? 'MXN'):'symbol':'1.2-2' }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-100 text-amber-600">
            <i class="pi pi-user text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Cliente</span>
        </div>
        <div class="p-4">
          @if (getChargeCustomer(charge); as customer) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              <div class="sm:col-span-2">
                <p class="text-xs font-medium text-slate-500">Razón social</p>
                <p class="text-sm font-semibold text-slate-900">{{ customer.legalName || '—' }}</p>
                @if (customer.comercialName) {
                  <p class="text-xs text-slate-500 mt-0.5">{{ customer.comercialName }}</p>
                }
              </div>
              @if (customer.taxId) {
                <div>
                  <p class="text-xs font-medium text-slate-500">RFC</p>
                  <p class="text-sm text-slate-700 font-mono">{{ customer.taxId }}</p>
                </div>
              }
              @if (customer.email) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Email</p>
                  <a [href]="'mailto:' + customer.email" class="text-sm text-sky-600 hover:text-sky-800">{{ customer.email }}</a>
                </div>
              }
              @if (customer.phone) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Teléfono</p>
                  <a [href]="'tel:' + customer.phone" class="text-sm text-sky-600 hover:text-sky-800">{{ customer.phone }}</a>
                </div>
              }
              @if (customer.firstName || customer.lastName) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Contacto</p>
                  <p class="text-sm text-slate-700">{{ (customer.firstName ?? '') + (customer.lastName ? ' ' + customer.lastName : '') || '—' }}</p>
                </div>
              }
              @if (customer.country?.name ?? customer.country?.code) {
                <div>
                  <p class="text-xs font-medium text-slate-500">País</p>
                  <p class="text-sm text-slate-700">{{ customer.country.name ?? customer.country.code ?? '—' }}</p>
                </div>
              }
              @if (customer.type) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Tipo</p>
                  <p class="text-sm text-slate-700">{{ customer.type }}</p>
                </div>
              }
              @if (customer.state) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Estado</p>
                  <p class="text-sm text-slate-700">{{ customer.state }}</p>
                </div>
              }
            </div>
          } @else {
            <p class="text-sm text-slate-500">Cliente ID: {{ charge.customerId ?? '—' }}</p>
          }
        </div>
      </div>

      @if (charge.payment) {
        <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
          <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
            <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
              <i class="pi pi-check-circle text-sm"></i>
            </span>
            <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Pago</span>
          </div>
          <div class="p-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              @if (charge.payment.status) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Estado</p>
                  <p-tag class="text-xs mt-0.5" [value]="getPaymentAttemptStatusLabel(charge.payment.status)" [severity]="getPaymentAttemptStatusSeverity(charge.payment.status)" />
                </div>
              }
              @if (charge.payment.paymentForm) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Forma de pago</p>
                  <p class="text-sm text-slate-700">{{ getPaymentFormLabel(charge.payment.paymentForm) }}</p>
                </div>
              }
              @if (charge.payment.amount != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Monto</p>
                  <p class="text-sm font-semibold text-slate-900">{{ charge.payment.amount | currency:(charge.payment.currency?.code ?? 'MXN'):'symbol':'1.2-2' }}</p>
                </div>
              }
              @if (charge.payment.providerId) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Referencia</p>
                  <p class="text-sm text-slate-700 font-mono">{{ charge.payment.providerId }}</p>
                </div>
              }
              @if (charge.payment.paidAt) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Pagado</p>
                  <p class="text-sm text-slate-700">{{ charge.payment.paidAt | date:'dd/MM/yyyy HH:mm' }}</p>
                </div>
              }
              @if (charge.payment.resultMessage) {
                <div class="sm:col-span-2 pt-2 border-t border-slate-100">
                  <p class="text-xs font-medium text-slate-500">Mensaje</p>
                  <p class="text-sm text-slate-700 mt-0.5">{{ charge.payment.resultMessage }}</p>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (charge.paymentLink) {
        <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
          <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
            <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
              <i class="pi pi-link text-sm"></i>
            </span>
            <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Liga de pago</span>
          </div>
          <div class="p-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              @if (charge.paymentLink.status) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Estado</p>
                  <p class="text-sm text-slate-700">{{ charge.paymentLink.status }}</p>
                </div>
              }
              @if (charge.paymentLink.concept) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Concepto</p>
                  <p class="text-sm text-slate-700">{{ charge.paymentLink.concept }}</p>
                </div>
              }
              @if (charge.paymentLink.totalAmount != null) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Monto</p>
                  <p class="text-sm font-semibold text-slate-900">{{ charge.paymentLink.totalAmount | currency:'MXN':'symbol':'1.2-2' }}</p>
                </div>
              }
              @if (charge.paymentLink.expiresAt) {
                <div>
                  <p class="text-xs font-medium text-slate-500">Expira</p>
                  <p class="text-sm text-slate-700">{{ charge.paymentLink.expiresAt | date:'dd/MM/yyyy HH:mm' }}</p>
                </div>
              }
              @if (charge.paymentLink.link) {
                <div class="sm:col-span-2">
                  <p class="text-xs font-medium text-slate-500">Enlace</p>
                  <a [href]="charge.paymentLink.link" target="_blank" rel="noopener noreferrer" class="text-sm text-sky-600 hover:text-sky-800">Abrir liga</a>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
            <i class="pi pi-history text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Intentos de pago</span>
        </div>
        @if (paymentAttemptsLoading()) {
          <div class="flex flex-col items-center justify-center py-8 gap-3">
            <i class="pi pi-spin pi-spinner text-2xl text-sky-500"></i>
            <p class="text-sm text-slate-500">Cargando intentos...</p>
          </div>
        } @else if (paymentAttempts().length === 0) {
          <p class="text-sm text-slate-500 px-4 py-3">No hay intentos de pago registrados.</p>
        } @else {
          <div class="divide-y divide-slate-100">
            @for (attempt of paymentAttempts(); track attempt.id ?? $index) {
              <div class="px-4 py-2">
              <div class="flex items-start gap-2">
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-2 min-w-0 flex-wrap">
                    <span class="text-xs font-medium text-slate-900">
                      {{ attempt.attemptedAt ? (attempt.attemptedAt | date:'dd/MM/yyyy HH:mm') : '—' }}
                    </span>
                    <p-tag
                      class="!text-xs"
                      [value]="getPaymentAttemptStatusLabel(attempt.status)"
                      [severity]="getPaymentAttemptStatusSeverity(attempt.status)" />
                  </div>
                  <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5">
                    <span class="text-xs text-slate-600">{{ getPaymentFormLabel(attempt.paymentForm) }}</span>
                    @if (attempt.providerId) {
                      <span class="text-xs text-slate-500 font-mono">{{ attempt.providerId }}</span>
                    }
                  </div>
                  @if (attempt.resultMessage) {
                    <p class="text-xs text-slate-500 mt-0.5">{{ attempt.resultMessage }}</p>
                  }
                </div>
                @if (attempt.id != null) {
                  <button
                    type="button"
                    class="shrink-0 inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium text-sky-700 hover:bg-sky-50"
                    [attr.aria-expanded]="expandedAttemptId() === attempt.id"
                    (click)="toggleAttemptEvents(attempt)">
                    <i class="pi text-[10px]" [class.pi-chevron-down]="expandedAttemptId() !== attempt.id"
                       [class.pi-chevron-up]="expandedAttemptId() === attempt.id"></i>
                    Historial
                  </button>
                }
              </div>
              @if (attempt.id != null && expandedAttemptId() === attempt.id) {
                <div class="mt-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2">
                  <app-collection-attempt-timeline
                    [events]="attemptEvents()[attempt.id] ?? []"
                    [loading]="attemptEventsLoadingId() === attempt.id" />
                </div>
              }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</p-drawer>
